<section class="pt-2 pb-12 sm:pt-6 sm:pb-16" #statsContainer>
    <div class="max-w-7xl mx-auto px-6 lg:px-8">
        <div class="stats-container">
            <div class="glow-circle-tr"></div>
            <div class="glow-circle-bl"></div>
            <div class="pointer-events-none absolute inset-0 opacity-20"></div>
            <div class="relative grid grid-cols-2 md:grid-cols-4 gap-8">
                <div *ngFor="let stat of stats; let i = index" class="text-center md:text-left" [attr.data-testid]="'stat-' + i">
                    <div class="font-display text-4xl sm:text-5xl font-extrabold text-white tracking-tight">
                        <span>{{ stat.value }}{{ stat.suffix }}</span>
                    </div>
                    <p class="mt-1.5 text-sm font-medium text-indigo-200">{{ stat.label }}</p>
                </div>
            </div>
        </div>
    </div>
</section>